import { Button } from '@/components/ui/button';
import { HStack } from '@chakra-ui/react';
import { useTranslations } from 'next-intl';
import { useQueryState } from 'nuqs';

type Props = {
  handleDeliveryTypeChange: (value: string) => void;
};

const DeliveryTypes: React.FC<Props> = ({ handleDeliveryTypeChange }) => {
  const t = useTranslations();
  const [orderType] = useQueryState('order_type', {
    defaultValue: 'delivery',
  });

  return (
    <HStack
      gap={1}
      p='1'
      bg={{ lg: 'white' }}
      borderRadius='16px'
      display='inline-flex'
    >
      {[
        { key: 'delivery', label: t('delivery') },
        { key: 'selfPickup', label: t('self-pickup') },
        { key: 'hall', label: t('reservations') },
      ].map((type) => {
        const isActive = orderType === type.key;
        return (
          <Button
            px={4}
            size='xl'
            h={{ base: '36px', lg: '48px' }}
            key={type.key}
            rounded={{ base: 'full', lg: '12px' }}
            variant='ghost'
            fontSize={{ base: '15px', lg: '16px' }}
            lineHeight='20px'
            fontWeight={{
              base: isActive ? 500 : 400,
              lg: isActive ? 600 : 500,
            }}
            color={isActive ? 'white' : 'text'}
            bg={{
              base: isActive ? '#F33535' : 'white',
              lg: isActive ? '#F33535' : 'transparent',
            }}
            onClick={() => handleDeliveryTypeChange(type.key)}
            _hover={{ bg: isActive ? '#E42C2C' : 'rgba(15,15,20,0.04)' }}
            _active={{ bg: isActive ? '#D62828' : 'rgba(15,15,20,0.08)' }}
          >
            {type.label}
          </Button>
        );
      })}
    </HStack>
  );
};

export default DeliveryTypes;
